import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SocieteModel, SocieteNode } from 'src/app/shared/models/simple-types/societe.model';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UserComponentsService } from '../user-components.service';
import { ToastrService } from 'ngx-toastr';
import { DroitService } from 'src/app/shared/services/simple/droit.service';
import { DroitModelDTO } from 'src/app/shared/dtos/droitModelDTO';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ArrayDataSource } from '@angular/cdk/collections';
import { UserModelDTO } from 'src/app/shared/dtos/userModelDTO';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';


@Component({
  selector: 'app-user-record',
  templateUrl: './user-record.component.html',
  styleUrls: ['./user-record.component.scss']
})
export class UserRecordComponent implements OnInit {

  user: UtilisateurModel;
  types: string[];
  niveaux: string[];
  societes: SocieteModel[];
  form: UntypedFormGroup;
  societe: SocieteModel;
  droits: DroitModelDTO[];
  societesNode: SocieteNode[];
  treeControl = new NestedTreeControl<SocieteNode>(node => node.children);
  dataSourceTree = new MatTreeNestedDataSource<SocieteNode>();
  droitsForm: UntypedFormArray;
  isDeleg = false;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private societeService: SocieteService,
    private toastr: ToastrService,
    private userComponentService: UserComponentsService,
    private droitService: DroitService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.societeService.getAll().subscribe(societes => {
        this.societes = societes;
      });
      this.societeService.getAllWithCa1().subscribe(societes => {
        this.dataSourceTree.data = societes;
        this.societesNode = societes;
      });
      this.onLoadUser(params.id).subscribe((user: UtilisateurModel) => {

      });
    });
  }

  hasChild = (_: number, node: SocieteNode) => !!node.children && node.children.length > 0;

  onLoadUser(id: number): Observable<UtilisateurModel> {
    return this.userService.get(id).pipe(tap((user: UtilisateurModel) => {
      if (user !== null && user !== undefined) {
        this.user = Object.assign({}, user);
        this.droitService.getAllFromUserDTO(user).subscribe(res => {
          this.droits = res;
          this.form = this.userComponentService.getEditUserFormGroup(user, this.droits);
          this.form.addControl('societe', new UntypedFormControl('', Validators.required));
          this.form.get('societe').setValue(user.societe);
          this.societe = user.societe;
        });
      }
    }));
  }

  verifDroitCreation(droit:DroitModelDTO[] ){
    let droitCrea = this.droits.filter(droit=>droit.createBc);
    if(droitCrea.length != 0){
      let destinationNonSelectionne = false;
      droitCrea.forEach(droit=>{
        if(!droit.commerce && !droit.fraisGeneraux && !droit.exploitation)
        {
          destinationNonSelectionne = true;   
        }
      });
      return destinationNonSelectionne;
    } else {
      return false;
    }
  }

  validate(): void {
    const userDTO = new UserModelDTO();
    userDTO.user = this.form.getRawValue();
    userDTO.user.societe = this.societe;
    userDTO.droits = this.form.get('droitsDTO').value;
    const updatedArray = userDTO.droits.map(obj => ({
      ...obj,
      refuse: false,
      messageRefus : ""
    })); //Vider les champs refuse et message refus avant d'envoyer au back
    userDTO.droits = Object.assign(updatedArray)
    this.droits = this.form.get('droitsDTO').value;
    
    //On vérifie si on a selectionné un droit création sans destination
    if(this.verifDroitCreation(this.droits.filter(droit=>droit.createBc))) {
        this.toastr.warning("Attention, vous avez selectionné le droit création sans destination. Vous ne pouvez pas enregistrer");
    } else {
      const dialogRef = this.dialog.open(SpinnerModalComponent);
      if(this.isDeleg){
        this.userService.updateUserAndDroitDelegation(userDTO).subscribe(res => {
          if(res.utilisateurModelDTO != null){
            this.user = res.utilisateurModelDTO.user;
            this.droits = res.utilisateurModelDTO.droits;
            this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
            dialogRef.close();
            this.toastr.success('Enregitrement des modifications', 'Modification réussie.');
          }else{
            if(res.listeDroitModelDTO != null)
            {
              const updatedArray = this.droits.map(obj => {
                const replacementObj = res.listeDroitModelDTO.find(r => r.idLigneTableau === obj.idLigneTableau);
                if (replacementObj) {
                  dialogRef.close();
                  return replacementObj;
                }
                dialogRef.close();
                return obj;
              });
              this.droits = Object.assign([],updatedArray);
              this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
              dialogRef.close();
              this.toastr.warning('Erreurs dans les droits', 'Modification non effectuée.');
            } else
              dialogRef.close();
          } 
        }, (error) => {
          dialogRef.close();
        });
      } else {
        this.userService.updateUserAndDroit(userDTO).subscribe(res => {
          if(res.utilisateurModelDTO != null){
            this.user = res.utilisateurModelDTO.user;
            this.droits = res.utilisateurModelDTO.droits;
            this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
            dialogRef.close();
            this.toastr.success('Enregitrement des modifications', 'Modification réussie.');
          } else {
            if(res.listeDroitModelDTO != null) {
              const updatedArray = this.droits.map(obj => {
                const replacementObj = res.listeDroitModelDTO.find(r => r.idLigneTableau === obj.idLigneTableau);
                if(replacementObj) {
                  dialogRef.close();
                  // Replace the object with the replacement object
                  return replacementObj;
                }
                dialogRef.close();
                // Return the original object if no replacement is found
                return obj;
              });
              this.droits = Object.assign([],updatedArray);
              this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
              dialogRef.close();
              this.toastr.warning('Erreurs dans les droits', 'Modification non effectuée.');
            } else 
            dialogRef.close();
          }  
        }, (error) => {
          dialogRef.close();
        });
      }
    }
  }

  onChangeSociete(societe: SocieteModel): void {
    if (societe) {
      this.societe = this.societes.find((soc: SocieteModel) =>  soc.id === societe.id);
      this.form.get('idSociete').setValue(societe.id);
      this.form.get('societe').setValue(societe);
    }
  }

  changedroit(){
    if(!this.isDeleg){
      this.droitService.getAllFromUserDTO(this.user).subscribe(res => {
        this.droits = res;
        this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
        this.form.addControl('societe', new UntypedFormControl('', Validators.required));
        this.form.get('societe').setValue(this.user.societe);
        this.societe = this.user.societe;
      });
    }else{
      this.droitService.getAllDroitDelegDTO(this.user).subscribe(res => {
        this.droits = res;
        this.form = this.userComponentService.getEditUserFormGroup(this.user, this.droits);
        this.form.addControl('societe', new UntypedFormControl('', Validators.required));
        this.form.get('societe').setValue(this.user.societe);
        this.societe = this.user.societe;
      });
    }    
  }

  addDroit(event: SocieteNode): void {
    const droit = new DroitModelDTO();
    if (event.societe === null) {
      droit.idSociete = event.id;
      droit.codeSociete = event.code;
    } else {
      droit.idSociete = event.societe.id;
      droit.codeSociete = event.societe.code;
      droit.codeCa1 = event.code;
    }
    droit.idUser = this.user.id;
    this.droits = this.form.get('droitsDTO').value;
    this.droits = [droit].concat(this.droits);
    const user = this.form.getRawValue();
    this.form = this.userComponentService.getEditUserFormGroup(user, this.droits);
  }

  deleteDroit(event: DroitModelDTO): void {
    this.droits = this.form.get('droitsDTO').value;
    const index = this.droits.indexOf(event);
    this.droits.splice(index, 1);
    const user = this.form.getRawValue();
    this.form = this.userComponentService.getEditUserFormGroup(user, this.droits);
  }

  close(): void {
    this.router.navigate(['/list-user/']);
  }
}
